import {getDateFromIsoString} from '@shared/api';
import {
  ReferralPaymentStatus,
  ReferralProgress,
  ReferralRecord,
  ReferralTargetAction,
} from '../types';
import {
  ReferralProgressOnBackend,
  ReferralRecordOnBackend,
} from './backendTypes';

export const mapReferralRecordFromBackend = ({
  master_account_id,
  referral_account_id,
  registered_at,
  first_real_order_at,
  target_action,
  payment_amount,
  payment_status,
  referral_pnl,
}: ReferralRecordOnBackend): ReferralRecord => ({
  masterAccountId: master_account_id,
  referralAccountId: referral_account_id,
  registeredAt: getDateFromIsoString(registered_at),
  firstRealOrderAt: first_real_order_at
    ? getDateFromIsoString(first_real_order_at)
    : null,
  targetAction: target_action as ReferralTargetAction,
  paymentAmount: payment_amount,
  paymentStatus: payment_status as ReferralPaymentStatus,
  referralPnl: referral_pnl,
});

export const mapReferralProgressFromBackend = ({
  registered_count,
  kyc_completed_count,
  deposited_count,
  inactive_count,
}: ReferralProgressOnBackend): ReferralProgress => ({
  registeredCount: registered_count,
  kycCompletedCount: kyc_completed_count,
  depositedCount: deposited_count,
  inactiveCount: inactive_count,
});
